// @ts-nocheck

import moment from 'moment';

export const getDisabledEqipmentInstallRemoveDate = (currentDate) => {
  return moment(currentDate).isAfter(moment().endOf('day'));
};
